module.exports = __webpack_public_path__ + "static/media/swirl.8bbd90a2.png";